<template>
  <div class="rootTable">
    <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white">
      <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
        <div class="mint-searchbar" style="padding: 0">
          <div class="mint-searchbar-inner">
            <i class="mintui mintui-search"/>
            <input type="search" placeholder="搜索" class="mint-searchbar-core" v-model="searchKey"
                   @input="search()"/>
            <a class="mint-searchbar-cancel" style="display: none;">取消</a>
          </div>
          <div class="mint-search-list" style="display: none;">
            <div class="mint-search-list-warp"/>
          </div>
        </div>
      </div>
      <div style="float: left;">
        <img src="../../../assets/images/32/sort.png" @click="showMenu"
             style="margin-right:5px ;padding: 0" height="20"
             width="20"
             slot="icon" alt="">
      </div>
    </header>
    <ul>
      <li v-for="item in BirthdayList" :key="item.iD" @click="analysis(item.iD)">
        <CellSwipe :right="(isManagerPage)?[ {
                    content:'移除',
                    style: { background:'#18bd5e', color: '#fff'},
                    handler: () => removeBirthday(item.iD)
                }, {
                    content:'修改',
                    style: { background:'#1590dc', color: '#fff'},
                    handler: () => updateBirthday(item)
                }
            ]:[]"
                   :style="{'background-color':(isManagerPage&&item.isInGroup)? '#c1dcee':'white','margin-left': '-0.5rem','margin-right': '-0.5rem','padding-left': '0.5rem','padding-right': '0.5rem'}">
          <div class="div-root">
            <div class="div-left">
              <div class="div-right2-top">
                <div v-html="$options.filters.font_color(item)"></div>
                <img v-if="item.sex === '男'" src="../../../assets/images/16/man.png" alt=""/>
                <img v-else src="../../../assets/images/16/woman.png" alt=""/>
              </div>
              <div class="div-right2-bottom">
                <div><span>{{ item.wechatname }}</span></div>
              </div>
            </div>
            <div class="div-right2" :style="{'color': item.deadDate !== null?'gray':'green'}">
              <div class="div-right2-top">
                <span>{{ item.dateOfBirth }}</span>
              </div>
              <div class="div-right2-bottom" :style="{'color': item.deadDate !== null?'gray':'blue'}">
                <span>{{ item.age }}</span>
                <span v-if="item.deadDate !== null">{{ item.realAge }}</span>
                <span>{{ item.zodiac }}</span>
                <span>{{ item.constellation }}</span>
              </div>
            </div>
            <div class="div-right3" :style="{'color': item.deadDate !== null?'gray':'green'}">
              <div class="div-right2-top" v-if="item.isBirthday">
                <span>{{ item.toolTip }}</span>
              </div>
              <div class="div-right2-top" v-else>
                <span>距离生日:</span>
                <span :style="{'color': item.nextDay<=10?'red':item.deadDate !== null?'gray':'blue'}">{{
                    item.nextDay
                  }}</span>
                <span>天</span>
              </div>
              <div class="div-right2-bottom">
                <span>{{ item.toolTipDetails }}</span>
              </div>
              <div style="clear:both;">
                <img v-if="item.isBirthday" src="../../../assets/images/32/birthday.png" width="20" height="20" alt=""
                     style="margin-bottom: 0.3rem;margin-left: 0.1rem"/>
              </div>
            </div>
          </div>
        </CellSwipe>
      </li>
    </ul>
    <Divider><span>总计：{{ BirthdayList.length }}个生日</span></Divider>
    <div class="empty-div">
      <div>
        <img src="../../../assets/images/no_data.png" v-if="showEmptyImage" alt=""/>
      </div>
    </div>
    <vue-context-menu class="right-menu" :contextMenuData="contextMenuData"
                      @sortByAge="sortByAge"
                      @sortByName="sortByName"
                      @SortByDays="SortByDays"
                      @SortByShengXiao="SortByShengXiao"
                      @sortByXingZhuo="sortByXingZhuo"
                      style="margin: 2.55rem 0 0 0.8rem">
    </vue-context-menu>
    <PaletteButton :offset="20" :radius="80" content="+"
                   style="position: fixed;right: 10px;bottom:10px"
                   mainButtonStyle="color:green;background-color:#5ee79d;" @expand="Expanded()"
                   @collapse="Collapse()">
      <div class="my-icon-button"
           :style="{'visibility':PaletteButtonVisibility}"
           @touchstart="ImportCircle()"><span>导入</span></div>
      <div class="my-icon-button"
           :style="{'visibility':PaletteButtonVisibility}"
           @touchstart="AddCircle()"><span>添加</span></div>
    </PaletteButton>
  </div>
</template>
<script>
import {CellSwipe, PaletteButton} from 'mint-ui';
import {Divider} from 'vant';
import 'vant/lib/divider/index.css'

export default {
  name: "CircleBirthday",
  components: {
    CellSwipe, PaletteButton, Divider
  },
  data() {
    return {
      PaletteButtonVisibility: 'collapse',
      isManagerPage: false,
      qznm: null,
      sortType: 2,
      contextMenuData: {
        //菜单显示的位置
        axis: {
          x: null,
          y: null,
        },
        //菜单选项
        menulists: [
          {
            fnHandler: "SortByDays",
            btnName: "按天数排序",
          }, {
            fnHandler: "sortByAge",
            btnName: "按年龄排序",
          },
          {
            fnHandler: "sortByName",
            btnName: "按姓名排序",
          },
          {
            fnHandler: "SortByShengXiao",
            btnName: "按生肖排序",
          }, {
            fnHandler: "sortByXingZhuo",
            btnName: "按星座排序",
          },
        ],
      },
      searchKey: null,
      BirthdayList: [],
      BirthdayList_Temp: [],
      Birthday: {
        age: null,
        realAge: null,
        constellation: null,
        dateOfBirth: null,
        dateOfBirthDay: null,
        dateType: null,
        eightCharacters: null,
        fiveElements: null,
        fiveElementsScore: null,
        iD: null,
        name: null,
        wechatname: null,
        isInGroup: false,
        isTop: false,
        topTime: null,
        remarks: null,
        sex: null,
        timeOfBirth: null,
        toolTip: null,
        toolTipDetails: null,
        zodiac: null,
        isBirthday: null
      },
      showEmptyImage: false,
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getCircleBirthdayListUrl: '/api/circle/getCircleBirthdayList',
      removeBirthdayUrl: '/api/circle/removeBirthday',
    }
  },
  filters: {
    font_color: function (val) {
      if (val.deadDate !== null) {
        return '<div style="color:gray;float: left">' + val.name + '</div>'
      } else if (val.name === '自己') {
        return '<div style="color:red;float: left">' + val.name + '</div>'
      }
      return '<div style="color:green;float: left">' + val.name + '</div>'
    }
  },
  mounted() {
    if (this.$route.query.qznm !== undefined) {
      this.qznm = this.$route.query.qznm
      this.getBirthdayList()
    } else {
      this.$router.go(-1)
    }

    this.isManagerPage = Boolean(Number(this.$route.query.isManagerPage))
  },
  methods: {
    updateBirthday(item) {
      this.$router.push({path: 'm_update_birthday', query: {birth: item}})
    },
    Expanded() {
      this.PaletteButtonVisibility = 'visible'
    },
    Collapse() {
      this.PaletteButtonVisibility = 'collapse'
    },
    ImportCircle() {
      this.$router.push({path: 'm_import_birthday', query: {qznm: this.qznm, list: this.BirthdayList}})
    },
    AddCircle() {
      this.$router.push({path: 'm_birthday_add', query: {qznm: this.qznm, sfqnsr: '1'}})
    },
    removeBirthday(csrqnm) {
      let that = this
      that.$messagebox.confirm("确认移除?").then(action => {
        if (action === 'confirm') {
          that.$ajax({
            method: 'get',
            url: that.removeBirthdayUrl,
            params: {qznm: that.qznm, csrqnm: csrqnm},
            headers: {token: that.token}
          }).then((response) => {
            if (!response.data.result) {
              that.$messagebox.alert(response.data.message)
            }
            that.$router.go(0)
          }).catch(response => {
            that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
          })
        }
      })
    },
    showMenu() {
      const x = document.documentElement.clientWidth
      const y = -15
      // Get the current location
      this.contextMenuData.axis = {
        x, y
      }
    },
    SortByDays() {
      this.sortType = 1
      this.getBirthdayList()
    },
    sortByAge() {
      this.sortType = 2
      this.getBirthdayList()
    },
    sortByName() {
      this.sortType = 3
      this.getBirthdayList()
    },
    SortByShengXiao() {
      this.sortType = 4
      this.getBirthdayList()
    },
    sortByXingZhuo() {
      this.sortType = 5
      this.getBirthdayList()
    },
    search() {
      if (this.searchKey === null) {
        return
      }
      if (this.searchKey === '') {
        this.BirthdayList = this.BirthdayList_Temp
        return
      }
      let temp = []
      this.BirthdayList_Temp.forEach(item => {
        if (item.name.includes(this.searchKey)) {
          temp.push(item)
        }
      })
      this.BirthdayList = temp
    },
    analysis(id) {
      this.$router.push({name: 'm_birthday_details', params: {csrqnm: id}})
    },
    async getBirthdayList() {
      let that = this
      await this.$ajax({
        method: 'get',
        url: this.getCircleBirthdayListUrl,
        params: {qznm: this.qznm, sortType: this.sortType},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          this.BirthdayList = response.data['responseData']
          this.BirthdayList_Temp = response.data['responseData']
          if (this.BirthdayList.length === 0)
            this.showEmptyImage = true
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  height: 30px;
  width: 100%;
  line-height: var(--footer-height);
  background: #42b983;
  color: #fff;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .no-child-btn {
  font-size: 16px;
  color: white;
  font-family: 黑体, serif;
  background: #4C4C4C;
  padding-left: 0;
  padding-right: 0;
  border-bottom: solid 0.5px white;
}

/deep/ .vue-contextmenu-listWrapper .context-menu-list .btn-wrapper-simple {
  height: 20px;
}

.right-menu {
  padding: 1.3rem 0 0 0;
  clip-path: polygon(90% 1%, 88% 11%, 100% 11%, 100% 100%, 0 100%, 0 11%, 78% 10%);
}

.rootTable {
  margin-top: -0.5rem;
  padding-bottom: 3.1rem;
  width: 100%;
  height: 100%;

  ul {
    list-style-type: none;
    margin: 3rem 0 0 0;

    li {
      height: 3rem;
      //margin-left: -2.5rem;
    }
  }

  /deep/ .vue-contextmenu-listWrapper {
    background: #4C4C4C;
  }


  .empty-div {
    position: absolute;
    left: 55%;
    top: 40%;
    transform: translate3d(-50%, -50%, 0);
  }

  a {
    text-decoration: none;
    color: blue;
  }

  span {
    font-size: 1.2rem;
  }
}

.popupstyle {
  width: 100px;
  height: 100px;

}

.div-root {
  height: 2.9rem;
  margin-left: -0.5rem;
  min-width: 24rem;
  text-align: left;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.div-left {
  width: 18%;
  margin-left: 0.2rem;
  display: flex;
  line-height: 1.5rem;
  flex-direction: column;

  .div-right2-top {
    text-align: left;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.9rem;
    }
  }

  .div-right2-bottom {

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.7rem;
      text-align: center;
      color: #42b983;
    }
  }
}

.div-right2 {
  width: 36%;
  margin-left: 0.2rem;
  display: flex;
  line-height: 1.5rem;
  flex-direction: column;

  .div-right2-top {
    max-height: 50%;
    display: table;
    text-align: center;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.9rem;
    }
  }

  .div-right2-bottom {
    max-height: 50%;
    display: table;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.8rem;
      text-align: center;
    }
  }
}

.div-right3 {
  width: auto;
  margin-left: 1.5rem;
  display: flex;
  line-height: 1.5rem;
  flex-direction: column;

  .div-right2-top {
    max-height: 50%;
    display: table;
    text-align: center;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.9rem;
    }
  }

  .div-right2-bottom {
    max-height: 50%;
    display: table;

    span {
      display: table-cell;
      vertical-align: center;
      font-size: 0.8rem;
      width: 33.33%;
      text-align: center;
    }
  }
}

.my-icon-button {
  background-color: #72d878;
  text-align: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
